export const name = 'rnUnsubscribe';

export default function rnUnsubscribe($log, $q, rnHttp, rnRegistry) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const EMAIL_SERVICE = 'email_service';

  /**
   * This is the externally facing API of the service
   */
  var service = {
    unsubscribe: unsubscribe
  };

  return service;

  /////////////////////
  // Private functions
  ////////////////////

  function unsubscribe(listId) {
    let link = {};
    link.op = 'DELETE';
    link.href = 'distribution-lists/'+ listId + '/users';

    return unsubscribeHalRequest(link);
  }

  function unsubscribeHalRequest(link, data, config) {
    let newLink = angular.copy(link);
    return appendServer(newLink.href)
      .then(function(href) {
        newLink.href = href;
        return rnHttp.halRequest(newLink, data, config);
      });
  }

  function appendServer(path) {
    return rnRegistry.getUrl(EMAIL_SERVICE, path);
  }

}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/unsubscribe/unsubscribe.service.js